import { render, staticRenderFns } from "./ActivityUsers.vue?vue&type=template&id=060a5258&scoped=true"
import script from "./ActivityUsers.vue?vue&type=script&lang=js"
export * from "./ActivityUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060a5258",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/chillzon/Documents/projects/crmeb_view/mer_plat_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('060a5258')) {
      api.createRecord('060a5258', component.options)
    } else {
      api.reload('060a5258', component.options)
    }
    module.hot.accept("./ActivityUsers.vue?vue&type=template&id=060a5258&scoped=true", function () {
      api.rerender('060a5258', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/lottery-assistant/activity/components/ActivityUsers.vue"
export default component.exports